/**
 * Adds data to the SSR editor node data providers store on the window object.
 * This allows multiple loaders to safely add data to the same object without
 * overwriting each other's data.
 *
 * @param data - The data to merge into the existing store
 */
export function addToSSREditorNodeDataProvidersStore(data: Record<string, unknown>): void {
	const existingData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
	window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = {
		...existingData,
		...data,
	};
}
